export enum FieldTypes {
    BOOLEAN = "boolean",
    TEXT = "text",
    ARRAY = "array",
    DATE = "date",
    TIME = "time"
}

export enum JobKeys {
    SOURCE = "sourceKey",
    DELIVERY = "deliveryKey",
    PROCESS = "processKey"
}